import Vue from 'vue';

const success = (context, response) => {
  if (response.data) {
    context.closeContractAuthModal();
    $("#contract-auth-modal").css({"display": "none"});
    toastr.success(response.data.msg);
    context.contract.verification_code = '';
    context.contract.request_id = '';
    !context.contract.id ? context.createBookingContract(context.contract) : context.updateBookingContract(context.contract)
  }

};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
  context.activeStep = 2;
};

export default (context, data) => {
  return Vue.$http.post('/check-contract-auth-verification-code', data).then(response => {
    if(response && response.status === 200) {
      success(context, response);
    }
  }).catch(error => {
    failed(context, error);
  })
};



// WEBPACK FOOTER //
// ./src/app/services/booking/checkContractAuthVerificationCode.js